import { IconCheck } from "@tabler/icons-react";
import { Typography, Badge } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import type { WarehouseAutoTuneConfiguration } from "../../types";

interface WarehouseAutoTuneBadgesProps {
  warehouseRK: string;
  autoTuneConfiguration: WarehouseAutoTuneConfiguration;
}

const WarehouseAutoTuneBadges = ({ autoTuneConfiguration }: WarehouseAutoTuneBadgesProps) => {
  const shutdownScalingEnabled = autoTuneConfiguration?.auto_tune_configuration?.auto_tune_enabled;
  const sizingEnabled = autoTuneConfiguration?.resizing_configuration?.resizing_enabled;
  const sizingMode = autoTuneConfiguration?.resizing_configuration?.resizing_configuration?.mode;

  if (!shutdownScalingEnabled && !sizingEnabled) {
    return null;
  }

  return (
    <Stack direction="row" gap="sm" align="center">
      {shutdownScalingEnabled && (
        <Badge variant="success" className="hover:!al-bg-green-100 !al-cursor-default">
          <IconCheck className="al-mr-2 al-size-4" />
          <Typography variant="body" weight="regular" size="sm">
            Warehouse Shutdown & Scaling
          </Typography>
        </Badge>
      )}

      {sizingEnabled && (
        <Badge variant="success" className="hover:!al-bg-green-100 !al-cursor-default">
          <IconCheck className="al-mr-2 al-size-4" />
          <Typography variant="body" weight="regular" size="sm">
            Warehouse Sizing ({sizingMode === "auto_resize" ? "Real-Time" : "Approval"})
          </Typography>
        </Badge>
      )}
    </Stack>
  );
};

export default WarehouseAutoTuneBadges;
